<div class="tw:h-32 tw:max-h-32 tw:w-full" echarts [options]="chartOptions"></div>
